<template>
    <div class="assign">
        <b-modal id="account-modal" centered size="lg" title="Edit Account Info">

            <b-form-group
                label="Email address:"
            >
                <b-form-input
                    id="user_name"
                    v-model="user.name"
                    type="text"
                    :state="errors.nameValid"
                    required
                    placeholder="Enter name"
                    @input="errors.nameValid = true; errors.name = ''"
                ></b-form-input>

                <b-form-invalid-feedback v-text="errors.name"></b-form-invalid-feedback>

            </b-form-group>

            <b-form-group
                label="Name:"
            >
                <b-form-input
                    id="user_email"
                    v-model="user.email"
                    type="email"
                    :state="errors.emailValid"
                    required
                    placeholder="Enter email"
                    aria-required="true"
                    @input="errors.emailValid = true; errors.email = ''"
                ></b-form-input>

                <b-form-invalid-feedback v-text="errors.email"></b-form-invalid-feedback>
            </b-form-group>


            <template #modal-footer="{ cancel, ok }">
                <b-button @click="cancel">Cancel</b-button>
                <b-button @click="updateUser()" variant="danger">Ok</b-button>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            user: {
                type: Object,
                required: true
            }

        },
        data() {
            return {
                selected: null,
                assignableUsers: [],
                assignedUsers: [],
                error: null,
                errors: {
                    name: '',
                    email: '',
                    nameValid: true,
                    emailValid: true
                }
            }
        },
        computed: {},
        mounted() {
        },
        methods: {

            updateUser() {
                let token = this.$store.state.token;
                let url = this.$store.state.apiURL + 'auth/me/update';
                let method = 'POST';

                axios({
                    url: url,
                    data: {
                        name: this.user.name,
                        email: this.user.email
                    },
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        let user = response.data;
                        this.$emit('ok', user);

                        this.$bvModal.hide('account-modal');

                        this.$bvModal.msgBoxOk('Your account was updated successfully.', {
                            title: 'Account updated',
                            okVariant: 'danger'
                        });

                    })
                    .catch(error => {
                        let data = error.response.data;

                        if (data.message) {
                            this.error = data.message;

                            if(data.errors.email){
                                this.errors.emailValid = false;
                                this.errors.email = data.errors.email;
                            }

                            if(data.errors.name){
                                this.errors.nameValid = false;
                                this.errors.name = data.errors.name;
                            }

                        } else {
                            alert('Something went wrong');
                        }
                    });
            },
        },
        watch: {},
    }
</script>
<style scoped>
    .pull-right {
        float: right;
    }
</style>
